export const TIMEZONE_COOKIE_NAME = 'shop_timezone';
export const COOKIE_MAX_AGE_30_DAYS = 60 * 60 * 24 * 30;
